import useAutoGeneration from '@/hooks/useAutoGeneration';
import useGenerationRecovery from '@/hooks/useGenerationRecovery';

/**
 * Generation lifecycle: kicks off any deeplink-driven auto-generation once
 * preconditions resolve, and recovers persisted in-flight generations on
 * boot.
 */
const useGenerationBootstrap = () => {
  useAutoGeneration();
  useGenerationRecovery();
};

export default useGenerationBootstrap;
